export const AccessibilityType = {
	IS_ACCESSIBLE_PICKUP: 1,
	IS_NOT_ACCESSIBLE_PICKUP: 0
}
